import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery } from '@tanstack/react-query';
import { TeamYearlyBonusResultResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  year: number;
};

const getTeamYearlyBonusResults = async (
  params: Params
): Promise<TeamYearlyBonusResultResponse> => {
  const { data } = await api.get<TeamYearlyBonusResultResponse>(
    `${BI_BASE_URL}/managers/team/yearly/bonus/results`,
    {
      params,
    }
  );
  return data ?? [];
};

export const useGetTeamYearlyBonusResults = ({ year }: Params) => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.TEAM_YEARLY_BONUS_RESULTS, year],
    queryFn: () => getTeamYearlyBonusResults({ year }),
  });
};
